import { DEFAULT_PAGE_SIZE } from '@/fsd/entities/cashbox/model/consts/consts';
import { usePaginationQueryParams } from '@/fsd/shared/hooks/usePageQueryParam';

export const usePagination = () => {
  const { page, pageSize, setPagination } =
    usePaginationQueryParams(DEFAULT_PAGE_SIZE);

  // @ts-ignore
  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    value: number
  ) => {
    setPagination({ page: value, pageSize });
  };

  const handlePageSizeChange = (value: number) => {
    setPagination({ page: 1, pageSize: value });
  };

  const setPage = (value: number) => {
    setPagination({ page: value, pageSize });
  };

  return {
    page,
    pageSize,
    handlePageChange,
    handlePageSizeChange,
    setPage,
  };
};
